const modulesFiles = require.context('./modules', true, /\.js$/);

const routes = modulesFiles.keys().reduce((accumulator, modulePath) => {
  const value = modulesFiles(modulePath);
  return accumulator.concat(value.default);
}, []);

export default routes;
